var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid__tr"},_vm._l((_vm.cols),function(col){return _c('div',{staticClass:"grid__column-header",style:([_vm.style, col.style])},[_vm._v(_vm._s(_vm.getText_(col)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }